import React from "react";
import { PageLayout } from "../components/PageLayout";
import ContactCTA from "../components/ContactCTA";
import 'react-responsive-carousel/lib/styles/carousel.min.css';

import wd1 from '../images/wedding/1.jpg';
import wd2 from '../images/wedding/2.jpg';
import wd3 from '../images/wedding/3.jpg';
import wd4 from '../images/wedding/4.jpg';
import wd5 from '../images/wedding/5.jpg';
import wd6 from '../images/wedding/6.jpg';

import { Carousel } from 'react-responsive-carousel';

const Wedding = () => {
  document.title = "Wedding - Hampton Jitney Charters";
  return (
    <PageLayout>
      <div className="flex-grow overflow-y-scroll">
        <div className="border border-black rounded-lg p-4 mt-4 bg-white bg-opacity-75 mx-4">
          <div class="px-4">
            <div class="flex flex-wrap -mx-4">
              <div class="relative w-full lg:w-1/2 px-4 mb-6 lg:mb-0 lg:pr-24 xl:pr-40">
                <div class="max-w-md md:max-w-lg mx-auto lg:mr-0 mb-12 md:mb-20">
                  <h1 class="font-heading text-5xl xs:text-5xl md:text-4xl font-bold text-gray-900">
                    <span class="block">Weddings with a Hampton Jitney Trolley</span>
                    <span class="block font-serif italic">An unforgettable experience</span>
                  </h1>
                  <img className="mt-10" src={wd3} alt="ig3" />
                </div>
                <img class="block w-full" src="saturn-assets/images/content/image-big-article.png" alt="" />
              </div>
              <div class="w-full lg:w-1/2 px-4">
                <div class="max-w-md md:max-w-lg xl:max-w-2xl mx-auto lg:mx-0">
                  <p class="text-2xl text-gray-800 mb-8">
                    Hampton Jitney offers vintage wedding trolleys for a stylish and nostalgic touch to your special day.
                  </p>
                  <p class="text-lg font-semibold text-gray-800 mb-8">
                    These trolleys provide a charming backdrop for wedding festivities, whether it's transporting the wedding 
                    party, capturing memorable photos, or giving guests a unique experience.
                  </p>
                  <p class="text-lg text-gray-700 mb-8">
                    With spacious interiors, classic design, open-air seating, panoramic windows, and charming 
                    details, our trolleys offer comfort and a delightful journey. Our dedicated team takes care 
                    of all the details to ensure a flawless and memorable transportation experience.
                  </p>
                  <ContactCTA
                    bgColor='bg-red-300'
                    heroImg={wd5}
                    heroAlt={"Book a trolley for your wedding today"}
                    ctaText={"Get a customized quote for your special day"}
                    bodyText={"Contact us at 631-283-4600, extension 642, or <a href='mailto:charter@hamptonjitney.com'>charter@hamptonjitney.com</a>. Let us help create lasting memories on your wedding day."}
                  />
                </div>
              </div>
            </div>
          </div>
          <Carousel
            className="flex justify-between w-[60%] mt-4 mx-auto mt-20"
            showArrows={true}
            infiniteLoop={true}
            showThumbs={false}
            showStatus={false}

          >
            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={wd1} alt="ig1" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={wd2} alt="ig2" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={wd3} alt="ig4" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={wd4} alt="ig4" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={wd5} alt="ig5" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

            <div>
              <img className="aspect-w-1 aspect-h-1 rounded-lg shadow-md" src={wd6} alt="ig6" />
              <p className="mt-4 text-center text-gray-700"></p>
            </div>

          </Carousel>

        </div>
      </div>
    </PageLayout>
  );
};

export default Wedding;
